export default "/048cb1f2b29308e18768c65cfd51e426596a830c/fbf1cfaf74329f9a6a1fed67972e7c52.svg";